const unwrap = response => response.data.data;

export default http => ({
    async list(params) {
        return unwrap(await http.get("/api/mysfc/sap-integration-report", { params }));
    },
    async detail(id) {
        return unwrap(await http.get(`/api/mysfc/sap-integration-report/${id}`));
    }
});
